// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';

export default class ConfirmView extends JQueryView {
  constructor() {
    super('.confirm');
  }

  @on({
    event: 'change',
    selector: '#officer_approval_stockholder_meeting_resolution_report_content',
  })
  onChangeContent() {
    const content = $(
      '#officer_approval_stockholder_meeting_resolution_report_content',
    );
    if (content.val().length > 0) {
      content.removeClass('is-invalid');
    }
    $('input:hidden[name="test_comment"]').val(content.val());
  }

  @on({
    event: 'change',
    selector: '#test_email',
  })
  onChangeTestEmail() {
    const email = $('#test_email');
    if (email.val().length > 0) {
      email.removeClass('is-invalid');
    }
  }

  @on({
    event: 'click',
    selector: '.submit_button',
  })
  onClickSubmitButton(event: any) {
    const content = $(
      '#officer_approval_stockholder_meeting_resolution_report_content',
    );
    const email = $('#test_email');
    if (content.val().length === 0) {
      content.addClass('is-invalid');
      alert('本文を入力してください');
      event.preventDefault();
    }
    if (email.val().length === 0) {
      email.addClass('is-invalid');
      alert('メールアドレスを入力してください');
      event.preventDefault();
    }
  }
}
